//nome = codigo no BD
export const enum EGuidStatusSasProposta {
  //1
  'Ativa' = '1ca99c7d-e52f-4f68-a3a7-40ee54054e50',
  //2
  'Inativa' = '4aa5af16-3276-4946-afcb-465548ced278',
}
